<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#4f2b1b">
      <path
        d="m15 30a15 15 0 0 1 -10.61-4.39 15.24 15.24 0 0 1 -3.21-4.77 15 15 0 0 1 24.43-16.45 15.13 15.13 0 0 1 3.21 4.77 15 15 0 0 1 0 11.68 15 15 0 0 1 -8 8 15 15 0 0 1 -5.82 1.16m0-28.43a13.38 13.38 0 0 0 -5.23 1.05 13.49 13.49 0 0 0 -7.15 7.15 13.55 13.55 0 0 0 0 10.46 13.49 13.49 0 0 0 7.15 7.15 13.55 13.55 0 0 0 10.46 0 13.49 13.49 0 0 0 7.15-7.15 13.55 13.55 0 0 0 0-10.46 13.49 13.49 0 0 0 -7.15-7.15 13.38 13.38 0 0 0 -5.23-1"
      />
      <path
        d="m24.06 9.68c-1.88-.62-4.84-.19-6.17 1.16a5.12 5.12 0 0 0 -1.12 3.8l.05.09a10.42 10.42 0 0 0 -1.88 2.89 8.78 8.78 0 0 0 -1.44-3.12 5.5 5.5 0 0 0 -.17-4.08c-.93-1.59-3.92-2.36-5.77-2.34-4 .05-2.9.13-2.9.13a19.18 19.18 0 0 0 3.75 6.7 3.2 3.2 0 0 0 4.45.52c.15.24.29.48.42.73s.12.22.17.33l.07.14s.05.12.05.13a4.57 4.57 0 0 1 .22.62 5.58 5.58 0 0 1 .16.68s0 .13 0 .14 0 .08 0 .12 0 .25 0 .38a10.73 10.73 0 0 0 -.53 3.4 15.45 15.45 0 0 0 .44 3.65l1.14-.26a11.5 11.5 0 0 1 .27-7 9.92 9.92 0 0 1 2-3.29 3.19 3.19 0 0 0 4.32.76 17.73 17.73 0 0 0 5.3-5.3s1.05.34-2.83-.98z"
      />
    </g>
  </svg>
</template>
